import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  finalize,
  tap,
} from 'rxjs/operators';
import { CrudService } from 'src/app/shared/crud/crud.service';

import { QueryParamsModel } from './query-models/query-params.model';
import { QueryResultsModel } from './query-models/query-results.model';

// Angular
// RxJS
// CRUD
export class BaseDataSource implements DataSource<any> {
  entitySubject = new BehaviorSubject<any[]>([]);
  rootSubject = new BehaviorSubject<any>(null);
  hasItems: boolean = true;

  loading$ = new BehaviorSubject<boolean>(false);
  loading = false;
  isPreloadTextViewed$: Observable<boolean> = of(true);

  paginatorTotalSubject = new BehaviorSubject<number>(0);
  paginatorTotal$: Observable<number>;
  subscriptions: Subscription[] = [];

  hasNext = false;
  currentPage = 0;

  constructor(protected service: CrudService<any>) {
    this.paginatorTotal$ = this.paginatorTotalSubject.asObservable();

    // const hasItemsSubscription = this.paginatorTotal$
    //   .pipe(distinctUntilChanged())
    //   .subscribe((res) => (this.hasItems = res > 0));
    // this.subscriptions.push(hasItemsSubscription);
  }

  loadList(queryParams: QueryParamsModel) {
    this.service.lastFilter$.next(queryParams);
    this.loading$.next(true);
    this.loading = true;
    this.isPreloadTextViewed$ = this.loading$.asObservable();

    this.service
      .list(queryParams)
      .pipe(
        tap((res: any) => {
          this.entitySubject.next(res['hydra:member']);
          this.rootSubject.next(res);
          this.paginatorTotalSubject.next(res['hydra:totalItems'] || 0);
          this.hasNext = !!res['hydra:view']?.['hydra:next'];
          this.currentPage = queryParams?.pageNumber;
          this.hasItems = res['hydra:member'].length > 0;
        }),
        catchError((err) => of(new QueryResultsModel([], err))),
        finalize(() => {
          this.loading$.next(false);
          this.loading = false;
        })
      )
      .subscribe();
  }

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.entitySubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.entitySubject.complete();
    this.paginatorTotalSubject.complete();
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
